import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth.guard';
import { DevGuard } from 'app/guards/dev.guard';
import { NoFoundComponent } from './no-found/no-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'configurator',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: async () => (await import('./auth/auth.module')).AuthModule,
    data: { title: 'UGOL.Авторизация' },
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./account/account.module')).AccountModule,
    data: { title: 'UGOL.Личный кабинет' },
  },
  {
    path: 'configurator',
    canActivate: [AuthGuard],
    loadChildren: async () =>
      (await import('./configurator/configurator.module')).ConfiguratorModule,
    data: { title: 'UGOL.Конфигуратор' },
  },
  {
    path: 'wizard',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./wizard/wizard.module')).WizardModule,
    data: { title: 'UGOL.Конфигуратор' },
  },
  {
    path: 'marketing',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./marketing/marketing.module')).MarketingModule,
    data: { title: 'UGOL.Конфигуратор' },
  },
  {
    path: 'quiz',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./quiz/quiz.module')).QuizModule,
    data: { title: 'UGOL.Конфигуратор' },
  },
  {
    path: 'sketch',
    canActivate: [DevGuard],
    loadChildren: async () => (await import('./sketch/sketch.module')).SketchModule,
    data: { title: 'UGOL.Дизайн' },
  },
  { path: '**', component: NoFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
